export const PdfConfig = {
  color: {
    text: "#801818",
    stroke: "#801818"
  }
};
